import React from 'react';
import { t, getKeyValue } from 'Src/i18n';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Tag } from 'Components/frameworks/tag/Tag';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { useAppContext } from 'Context/ReactAppContext';
import { getDiscountValueFromProposal } from './ProposalAccommodationTitleUtils';
type PromotionTagProps = {
  proposal: Proposal;
  uniqDiscounts: Array<number>;
};
export const PromotionTag = ({ proposal, uniqDiscounts }: PromotionTagProps) => {
  const appContext = useAppContext();
  const { isRTL } = useResponsive();
  const isHappyFirstEnabled = isFeatureFlipped(appContext)('booking.promotionHappyFirst') || true;
  const discountValue = getDiscountValueFromProposal(proposal);
  const discountIndex = uniqDiscounts.indexOf(discountValue);
  const showDisclamer = getKeyValue('booking.accommodation.promotion.showDisclamer');
  const disclamerStars = showDisclamer ? '*'.repeat(discountIndex + 1) : '';
  const proposalHasHappyFirstOffer = !!discountValue;
  const shouldShowHappyFirstTags = isHappyFirstEnabled && proposalHasHappyFirstOffer;

  if (!shouldShowHappyFirstTags) {
    return null;
  }

  const chargePercentage = t('booking.banking.paymentMethod.chargePercentage', {
    charge_percentage: discountValue || 0,
  });
  const promotionLabel = isRTL
    ? `${disclamerStars} ${chargePercentage} -`
    : `- ${chargePercentage} ${disclamerStars}`;
  return (
    <div className="mt-8 flex justify-center sm:mt-0 sm:justify-end">
      <Tag
        data-testid="promotion-tag"
        className="border-sienna bg-sienna leading-normal text-white"
      >
        {promotionLabel}
      </Tag>
    </div>
  );
};
